<template>
  <div>
    <Header page="my_page"/>
    <b-container>
      <div class="d-flex justify-content-center mypage mt-34">
        <div class="mypage_content">
          <SidebarMypage />
          <form action="" class="mw-536">
            <div class="form-group mb-0">
              <label for="" class="mypage__label">社員コード</label>
              <input type="text" name="" class="input-form" placeholder="社員コードを入力してください" :value="editMyPage.employee_code" disabled>
            </div>
            <div class="form-group mb-0">
              <label for="" class="mypage__label">お名前<span class="required">*</span></label>
              <div class="input-group">
                <input type="text" name="" class="input-form" placeholder="お名前を入力してください" v-model="editMyPage.name" :class="{error: !$v.editMyPage.name.required && invalid}" maxlength="50">
                <small v-if="!$v.editMyPage.name.required && invalid" class="text-input error">{{message.NAME_REQUIRED}}</small>
              </div>
            </div>
            <div class="form-group mb-0">
              <label for="" class="mypage__label">所属</label>
              <div class="input-group">
                <input type="text" id="phone" name="userName" class="input-form" placeholder="所属を入力してください" :value="editMyPage.position" disabled>
              </div>
            </div>
            <div class="form-group mb-0">
              <label for="" class="mypage__label">電話番号</label>
              <div class="input-group">
                <input type="text" id="userName" name="userName" class="input-form" placeholder="電話番号を入力してください" :class="{'error': !$v.editMyPage.phone.valid && invalid}" v-model="editMyPage.phone" @input="$v.editMyPage.phone.$touch()">
                <small v-if="!$v.editMyPage.phone.valid && invalid" class="text-input error">{{message.PHONE_FORMAT}}</small>
              </div>
            </div>
            <div class="form-group mb-0">
              <label for="" class="mypage__label">メールアドレス</label>
              <input type="text" name="" id="" class="input-form" placeholder="メールアドレスを入力してください" v-model="editMyPage.email" disabled>
            </div>
            <div class="d-none d-lg-block mb-30">
              <div class="d-flex mypage__btnGroup">
                <button class="btn btn-secondary btn-rounder mr-30" @click="goBack">キャンセル</button>
                <button class="btn btn-primary btn-rounder" @click="editProfile">保存</button>
              </div>
            </div>
            <div class="d-block d-lg-none">
              <div class="mb-btn admin-vendor-btnGroup mt-30">
                <button class="btn btn-primary btn-rounder" @click="editProfile" type="button">保存</button>
                <button class="btn btn-secondary btn-rounder btn-space" type="button" @click="goBack">キャンセル</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import SidebarMypage from '@/views/Manager/MyPage/SideBarEditMyPage'
import Header from '@/components/share/Header'
import {mapState} from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { MESSAGE } from '@/utils/errorjapanese'
export default {
  name: 'EditMypage',
  data () {
    return {
      message: MESSAGE,
      invalid: false
    }
  },
  validations: {
    editMyPage: {
      name: {
        required
      },
      phone: {
        valid (phone) {
          if (phone) {
            const validate = /^[0-9-.+]{3,20}$/i.test(phone)
            return validate
          }
          return true
        }
      }
    }
  },
  components: {
    Header,
    SidebarMypage
  },
  methods: {
    goBack () {
      this.$router.push('/manager/me')
    },
    editProfile (e) {
      e.preventDefault()
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      const formData = new FormData()
      if (this.editMyPage.avatar !== this.user.avatar) {
        formData.append('avatar', this.editMyPage.avatar)
      }
      if (this.editMyPage.phone) {
        formData.append('phone', this.editMyPage.phone)
      }
      if (this.editMyPage.position) {
        formData.append('position', this.editMyPage.position)
      }
      formData.append('email', this.editMyPage.email)
      formData.append('name', this.editMyPage.name)
      formData.append('_method', 'put')
      this.$store.dispatch('allAuth/editProfile', formData)
    }
  },
  computed: {
    ...mapState({
      user: state => state.allAuth.user,
      editMyPage: state => state.allAuth.editMyPage,
      errorMyPage: state => state.allAuth.errorMyPage
    })
  },
  mounted () {
    this.$store.dispatch('allAuth/getProfile')
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/mypage/detail_mypage.scss";
  @import '@/assets/stylesheet/admin/mypage.scss';
</style>



// WEBPACK FOOTER //
// src/views/Manager/MyPage/EditMypage.vue